import React from 'react';

const Products = () => {
  return (
    <section className="products-section">
      <h2>Benessere per il tuo bambino.<br />Tranquillità per te.</h2>
      <span className="bundle-text">♥ Sconto disponibile per la prima visita</span>

      <div className="products-grid">
        <div className="product-card">
          <i className="fa-solid fa-water product-icon"></i>
          <h3 className="product-title">Idroterapia</h3>
          <p className="product-desc">Galleggiamento in acqua calda per<br />rafforzare i muscoli e la fiducia</p>
          <button className="product-btn">Dettagli</button>
          <div className="price-from">Singola Sessione €60</div>
        </div>
        <div className="product-card">
          <i className="fa-solid fa-hands-holding-child product-icon"></i>
          <h3 className="product-title">Massaggio</h3>
          <p className="product-desc">Massaggio dolce completo per<br />migliorare sonno e digestione</p>
          <button className="product-btn">Dettagli</button>
          <div className="price-from">Aggiunta €30</div>
        </div>
        <div className="product-card">
          <i className="fa-solid fa-spa product-icon"></i>
          <h3 className="product-title">Spa Completa</h3>
          <p className="product-desc">La combinazione perfetta di<br />nuoto + massaggio</p>
          <button className="product-btn">Dettagli</button>
          <div className="price-from">Pacchetto €85</div>
        </div>
      </div>
      
      <div className="products-grid" style={{ marginTop: '30px' }}>
        <div className="product-card">
          <i className="fa-solid fa-users product-icon"></i>
          <h3 className="product-title">Genitori & Bebè</h3>
          <p className="product-desc">Impara tecniche di massaggio per<br />legare con il tuo bambino</p>
          <button className="product-btn">Orari</button>
          <div className="price-from">Corso Settimanale</div>
        </div>
        <div className="product-card">
          <i className="fa-solid fa-gift product-icon"></i>
          <h3 className="product-title">Buoni Regalo</h3>
          <p className="product-desc">Il regalo perfetto per<br />neogenitori e baby shower</p>
          <button className="product-btn">Acquista</button>
          <div className="price-from">Qualsiasi Importo</div>
        </div>
      </div>
    </section>
  );
};

export default Products;
